module.exports = __webpack_public_path__ + "img/milkyway-bg.7afc6150.jpg";